import { render } from "./Cartera-App.vue?vue&type=template&id=648f2a0f"
import script from "./Cartera-App.vue?vue&type=script&lang=js"
export * from "./Cartera-App.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__